import { Link } from "react-router-dom";
import { BRAND } from "../../lib/site";

export default function PageNav() {
  return (
    <header className="sticky top-0 z-50 bg-[#030712]/85 backdrop-blur-xl border-b border-white/10" data-testid="page-nav">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="pagenav-logo" className="flex items-center gap-3">
          <img src={BRAND.logo} alt="Yes Global" className="h-9 w-9 rounded-full object-cover ring-1 ring-white/20" />
          <div className="leading-none">
            <span className="block font-display text-[14px] font-bold tracking-tight text-white">YES GLOBAL</span>
            <span className="block font-body text-[9px] tracking-[0.3em] text-[#00D166]">CONSULTANTS</span>
          </div>
        </Link>
        <nav className="flex items-center gap-7">
          <Link to="/" className="font-body text-sm text-white/70 hover:text-white transition-colors" data-testid="pagenav-home">Home</Link>
          <Link to="/blog" className="font-body text-sm text-white/70 hover:text-white transition-colors" data-testid="pagenav-insights">Insights</Link>
          <Link to="/#contact" className="font-body text-sm font-semibold bg-[#00D166] text-[#030712] px-5 py-2.5 hover:bg-white transition-colors duration-300" data-testid="pagenav-contact">Consult Us</Link>
        </nav>
      </div>
    </header>
  );
}
